import React from 'react';
import { appPlaceholders } from '../data/site';
const HIGHLIGHT_SRC = 'https://cdn.magicpatterns.com/uploads/uL5FBMg8Ghv53D5sag9oF5/black-comet-labs-in-the-lab-highlight.png';

/** Standard Apple silhouette (Simple Icons), viewBox 0 0 24 24. */
const APPLE_PATH = 'M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701';
const SURFACES = ['bg-violet', 'bg-mist', 'bg-comet-green'];
function PhoneStudy() {
  return <div className="mx-auto w-[62%] max-w-[210px] rounded-[26px] border border-ink/25 bg-cream/70 p-3" aria-hidden="true" data-id="element-62" data-mp="1nnvrbsrcwz9c">
      <div className="mx-auto mb-3 h-1 w-10 rounded-full bg-ink/20" data-id="element-63" data-mp="37foeodci0409" />
      <div className="space-y-2.5" data-id="element-64" data-mp="32hwnjljoglx4">
        <div className="h-16 rounded-[6px] bg-ink/10" data-id="element-65" data-mp="32ksjj4byt0ix" />
        <div className="h-2 w-3/4 rounded-full bg-ink/15" data-id="element-66" data-mp="2yi4b2xr5xvmh" />
        <div className="h-2 w-1/2 rounded-full bg-ink/10" data-id="element-67" data-mp="2thzw5c5wl8yd" />
        <div className="grid grid-cols-2 gap-2.5 pt-1" data-id="element-68" data-mp="2tjkrh401kvxa">
          <div className="h-12 rounded-[6px] bg-ink/10" data-id="element-69" data-mp="3q8sao5d6usy1" />
          <div className="h-12 rounded-[6px] bg-ink/10" data-id="element-70" data-mp="3qad4fsroi7uu" />
        </div>
        <div className="h-2 w-2/3 rounded-full bg-ink/10" data-id="element-71" data-mp="3m7ymdavu3c4m" />
      </div>
    </div>;
}
export function InTheLab() {
  return <section id="lab" className="bg-cream py-20 md:py-28" data-id="element-72" data-mp="3hdudgm30cu0w">
      <div className="mx-auto max-w-content px-5 md:px-8 lg:px-10" data-id="element-73" data-mp="3cfszgfkfvkwa">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between" data-id="element-74" data-mp="dqlrxc3bk1oy">
          <div data-id="element-75" data-mp="9059fdkn5pvq">
            <h2 className="sr-only" data-id="element-76" data-mp="8zlso06q97ja">In the lab</h2>
            {/* Approved custom lettering, tightly cropped of its blank margins.
                The filter below knocks the artwork's light beige ground out to
                transparency by luminance, so only the violet fill, ink shadow
                and antialiased edges remain over the site cream. */}
            <svg width="0" height="0" aria-hidden="true" focusable="false" className="absolute h-0 w-0" data-id="element-77" data-mp="j1zhc67bipgs">
              <filter id="lab-lettering-knockout" colorInterpolationFilters="sRGB" data-id="element-78" data-mp="94l74obzmwwx">
                <feColorMatrix type="matrix" values="1 0 0 0 0
                          0 1 0 0 0
                          0 0 1 0 0
                          0.2126 0.7152 0.0722 0 0" data-id="element-79" data-mp="e6k7dpcfldpn" />
                <feComponentTransfer data-id="element-80" data-mp="1uj90ermjbfhk">
                  <feFuncA type="table" tableValues="1 1 1 1 1 1 0.92 0.12 0" data-id="element-81" data-mp="1ukafd76o8m4k" />
                </feComponentTransfer>
              </filter>
            </svg>
            <div className="w-[280px] max-w-full overflow-hidden sm:w-[380px] lg:w-[460px]" aria-hidden="true" data-id="element-82" data-mp="3j2v265shkqhy">
              <img src={HIGHLIGHT_SRC} alt="" className="-mb-[14%] -ml-[11%] -mt-[12%] w-[120%] max-w-none" style={{
              filter: 'url(#lab-lettering-knockout)'
            }} data-id="element-83" data-mp="3f2l0347tek8d" />
            </div>
          </div>
          <p className="max-w-sm text-[17px] leading-relaxed text-ink/70 lg:text-right" data-id="element-84" data-mp="6kose20lh9l0">
            A few things we&rsquo;re building. Each with a world of its own.
          </p>
        </div>

        <ul className="mt-14 grid grid-cols-1 gap-1 sm:grid-cols-2 lg:grid-cols-3" data-id="element-85" data-mp="fmo8ms3sc9mw">
          {appPlaceholders.map((app, index) => app.screenshot ? <li key={app.slot} className="flex" data-id="element-86" data-mp="al8p54h9ab6m">
                <article className="flex w-full min-w-0 flex-col bg-cream" data-id="element-87" data-mp="2hekjs0m1jhh5">
                  <img src={app.screenshot} alt={app.imageAlt} className="block aspect-square h-auto w-full object-contain" data-id="element-88" data-mp="2cey5roye1x7a" />
                  <div className="flex flex-1 flex-col border-t border-ink/15 px-6 pb-7 pt-6" data-id="element-89" data-mp="2iu5c2c5q2zci">
                    <div className="flex flex-wrap items-center gap-[10px]" data-id="element-90" data-mp="2nt9pxg3ldl96">
                      <span className="rounded-[2px] border border-ink/25 px-2 py-1 text-[10px] font-medium uppercase tracking-[0.16em] text-ink/70" data-id="element-91" data-mp="2ssukzffn59gm">
                        {app.storeURL ? 'Available now' : 'Coming soon'}
                      </span>
                      {app.platform === 'ios' ? <span role="img" aria-label="iOS" className="inline-flex shrink-0 items-center gap-[5px] text-ink" data-id="element-92" data-mp="253jucqs08vg7">
                          <svg viewBox="0 0 24 24" className="h-[22px] w-[22px]" fill="currentColor" aria-hidden="true" focusable="false" data-id="element-93" data-mp="1cfe5brtx4kak">
                            <path d={APPLE_PATH} data-id="element-94" data-mp="14w508asg37rb" />
                          </svg>
                          <span aria-hidden="true" className="text-[22px] font-semibold leading-none" style={{
                    fontFamily: 'Arial, Helvetica, sans-serif'
                  }} data-id="element-95" data-mp="zv7ifzbckfqc">
                            iOS
                          </span>
                        </span> : null}
                    </div>
                    <h3 className="mt-5 font-display text-[26px] font-semibold leading-tight text-ink" data-id="element-96" data-mp="h6andt84lj72">
                      {app.name}
                    </h3>
                    {app.subheading ? <p className="mt-2 text-[16px] font-bold leading-snug text-ink" data-id="element-97" data-mp="761og7mr1jnz">
                        {app.subheading}
                      </p> : null}
                    <p className="mt-3 text-[15px] leading-relaxed text-ink/75" data-id="element-98" data-mp="3opqxa7cm6k9x">
                      {app.description}
                    </p>
                  </div>
                </article>
              </li> : <li key={app.slot} className="flex" data-id="element-99" data-mp="3fqwwe4s937qk">
              <article className={`flex min-h-[420px] w-full flex-col lg:min-h-[480px] ${SURFACES[index % SURFACES.length]}`} data-id="element-100" data-mp="3ko5ds35kr7qr">
                <div className="flex items-start justify-end px-6 pt-6" data-id="element-101" data-mp="g9yyk1i5gytp">
                  <span className="rounded-[2px] border border-ink/25 px-2 py-1 text-[10px] font-medium uppercase tracking-[0.16em] text-ink/70" data-id="element-102" data-mp="gcbfqcg3355p">
                    {app.storeURL ? 'Available now' : 'Coming soon'}
                  </span>
                </div>

                <div className="flex flex-1 items-end justify-center px-6 pb-0 pt-8" data-id="element-103" data-mp="v6pmnemdio40">
                  <PhoneStudy data-id="element-104" data-mp="zyg5k8zdmk71" />
                </div>

                <div className="border-t border-ink/15 px-6 py-5" data-id="element-105" data-mp="1000yju61lv2s">
                  <p className="font-display text-[22px] font-medium leading-tight text-ink" data-id="element-106" data-mp="19bghub9jc7zc">
                    {app.name || app.label}
                  </p>
                  <p className="mt-1 text-[14px] leading-relaxed text-ink/70" data-id="element-107" data-mp="1j3cgbnfja043">
                    {app.description || 'Details coming soon.'}
                  </p>
                </div>
              </article>
            </li>)}
        </ul>
      </div>
    </section>;
}